<template>
  <h3 class="pt-3 text-lg sm:text-base font-light tracking-tight text-gray-700 dark:text-gray-200">
    <slot/>
  </h3>
</template>
